// Đồng hồ UI (TECH_BASELINE §6.2): MỘT setInterval 30s cho cả client; tab ẩn thì không chạy việc,
// hiện lại thì chạy ngay một nhịp. `now()` là cửa đọc giờ duy nhất (có lệch giờ dev).

export const UI_TICK_MS = 30_000;

type TickFn = (nowMs: number) => void;

let offsetMs = 0;
const listeners = new Set<TickFn>();
let timer: ReturnType<typeof setInterval> | null = null;
let visibilityBound = false;

export function now(): number {
  return Date.now() + offsetMs;
}

export function isHidden(): boolean {
  return typeof document !== 'undefined' && document.visibilityState === 'hidden';
}

function fire(): void {
  if (isHidden()) return;
  const n = now();
  for (const fn of [...listeners]) fn(n);
}

function arm(): void {
  if (timer === null && !isHidden()) timer = setInterval(fire, UI_TICK_MS);
}

function disarm(): void {
  if (timer !== null) clearInterval(timer);
  timer = null;
}

// Tab ẩn: dừng hẳn interval. Hiện lại: chạy ngay một nhịp rồi đặt lại interval.
function onVisibility(): void {
  if (isHidden()) return disarm();
  fire();
  arm();
}

function start(): void {
  if (!visibilityBound && typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', onVisibility);
    visibilityBound = true;
  }
  arm();
}

function stop(): void {
  disarm();
  if (visibilityBound && typeof document !== 'undefined') {
    document.removeEventListener('visibilitychange', onVisibility);
    visibilityBound = false;
  }
}

/** Đăng ký nghe nhịp 30s; trả hàm hủy. Không còn ai nghe thì đồng hồ tự tắt. */
export function onTick(fn: TickFn): () => void {
  listeners.add(fn);
  start();
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0) stop();
  };
}

export function isTicking(): boolean {
  return timer !== null;
}

/** Lệch giờ dev: `window.__clock.set(ms)`. */
export function setClockOffset(ms: number): void {
  offsetMs = ms;
  fire();
}

export function clockOffset(): number {
  return offsetMs;
}
